import { Grid, Typography } from "@material-ui/core";
import React from "react";
import Close from "@material-ui/icons/Close";
import styled from "styled-components";

export const Header = (props) => {
  return (
    <StyledGrid container>
      <Grid item>
        <Typography variant="h4">New Message</Typography>
      </Grid>
      <Grid item style={{ flex: "1" }}></Grid>
      <Grid item>
        <StyledCloseIcon onClick={props.closeModal} />
      </Grid>
    </StyledGrid>
  );
};

export default Header;

const StyledGrid = styled(Grid)`
  && {
    background-color: #404040;
    padding: 8px 20px;
    align-items: center;
    color: white;
  }
`;
const StyledCloseIcon = styled(Close)`
  && {
    color: white;
    font-size: 1.3rem;
    cursor: pointer;
  }
`; 